import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=7329f968&scoped=true"
import script from "./transactionDetail.vue?vue&type=script&lang=js"
export * from "./transactionDetail.vue?vue&type=script&lang=js"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&id=7329f968&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7329f968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7329f968')) {
      api.createRecord('7329f968', component.options)
    } else {
      api.reload('7329f968', component.options)
    }
    module.hot.accept("./transactionDetail.vue?vue&type=template&id=7329f968&scoped=true", function () {
      api.rerender('7329f968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/payment-link/components/tabs/transactionDetail.vue"
export default component.exports